var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FF9951"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 21.2876H19.8033C19.07 21.2876 18.3733 21.5718 17.86 22.0851L16.2925 23.6343C15.5775 24.3401 14.4133 24.3401 13.6983 23.6343L12.1308 22.0851C11.6175 21.5718 10.9117 21.2876 10.1875 21.2876H9.5C7.97833 21.2876 6.75 20.0685 6.75 18.5651V8.56427C6.75 7.06094 7.97833 5.8418 9.5 5.8418H20.5C22.0217 5.8418 23.25 7.06094 23.25 8.56427V18.5651C23.25 20.0593 22.0217 21.2876 20.5 21.2876Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2567 17.7147C15.1192 17.7605 14.89 17.7605 14.7433 17.7147C13.5517 17.3022 10.875 15.6063 10.875 12.7188C10.875 11.4446 11.9017 10.418 13.1667 10.418C13.9183 10.418 14.5783 10.7755 15 11.3346C15.4217 10.7755 16.0817 10.418 16.8333 10.418C18.0983 10.418 19.125 11.4446 19.125 12.7188C19.1158 15.6063 16.4483 17.3022 15.2567 17.7147Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLike);
export default __webpack_public_path__ + "static/media/chat-like.33741f10e3676ada1be21da9a6e3f70b.svg";
export { ForwardRef as ReactComponent };